// Core
import React, { Component } from 'react';
import ProgressRing from 'components/ProgressRing';

const ResolvedConversations = (resolvedConversations, totalConversations) => (
  <div className="ResolvedConversations BotStats-metricSingle">
    <div className="ringContainer">
      <ProgressRing
        highBreakpoint={50}
        radius={30}
        stroke={4}
        progress={makeProgress(resolvedConversations, totalConversations)}
      />
    </div>

    <div className="BotStats-metricSingleDetails">
      <div className="BotStats-metricSingleTitle">Resolved Conversations</div>
      <div className="BotStats-metricSingleBody">
        This bot has participated in {totalConversations} now closed
        conversations and successfully resolved {resolvedConversations} of them.
      </div>
    </div>
  </div>
);

export const makeProgress = (resolvedConversations, totalConversations) => {
  if (resolvedConversations === 0 || totalConversations === 0) {
    return 0;
  }

  return Math.round((resolvedConversations / totalConversations) * 100);
};

export default ResolvedConversations;
